export interface Project {
    image: string;
    filters: string[];
    name: string;
    link: string;
}

interface ProjectPieceProps {
    piece: Project;
}

const ProjectPiece = ({ piece }: ProjectPieceProps) => (
    <div className='col-md-4 col-sm-6 piece'>
        <div className='skillsLine'>
            <h4>{piece.name}</h4>
            <div>
                {piece.filters.map((filter) => (
                    <span key={filter}>{filter} </span>
                ))}
            </div>
        </div>
        <img src={piece.image} alt={piece.name} />
        <a href={piece.link} target='_blank' rel='noreferrer'>Visit site</a>
    </div>
);

export default ProjectPiece;
